/**
 * CommunityEditor Component
 * CodeMirror 6 기반 Bear 스타일 인라인 프리뷰 에디터
 * 커뮤니티 글쓰기 폼에서 textarea 대체용 래퍼
 */

import React from 'react';
import MarkdownEditor from './editor/MarkdownEditor';
import './CommunityEditor.css';

const CommunityEditor = ({ value, onChange, placeholder, minHeight = 200 }) => {
  return (
    <div className="community-editor" style={{ minHeight }}>
      {!value && placeholder && (
        <div className="community-editor-placeholder">{placeholder}</div>
      )}
      <MarkdownEditor
        content={value || ''}
        onChange={onChange}
      />
    </div>
  );
};

export default CommunityEditor;
